import React, {useEffect, useState, useCallback} from "react";
import SlotSelector from "../../common/components/slot-selector";
import TextBox from "../../../../components/forms/text-box";
import TextArea from "../../../../components/forms/text-area";
import SettingTip from "../../common/components/setting-tip";
import SentToUserSwitch from "../../common/components/send-to-user-switch";
import { ACTION_PROMPT } from "../../common/const/settings-type";

function AgentActionSettings({ name, onChangeData, savedSettings, metadata }) {
    const [formData, setFormData] = useState(savedSettings);

    const notifyOnchangeData = data => {
        data.stateType = ACTION_PROMPT
        onChangeData(data);
    }

    useEffect(() => {
        notifyOnchangeData(formData)
    }, [formData]);

    const handleChange = useCallback(event => {
        const { name, value } = event.target;

        setFormData(prevFormData => {
            return {
                ...prevFormData,
                [name]: value
            };
        });
    }, []);

    return (
        <div className="flex flex-col gap-2">

            <SettingTip text="Execute an agent action with the provided instructions"/>

            <TextBox
                label="Name"
                type="text"
                name="name"
                placeholder="State name"
                value={formData.name}
                onChange={handleChange}
            />

            <TextArea
                label="Action"
                name="action"
                placeholder="Describe the agent action"
                value={formData.action}
                onChange={handleChange}
                rows={6}
            />

            <SlotSelector
                title="Set result into variable"
                value={formData.slotToAssign}
                autoFillFromEntity={false}
                slots={metadata.slots}
                showCaptureFromUserInput={false}
                onChange={(e)=>handleChange({target: { name: 'slotToAssign', value: e.target.value }})}
                />

            <div className="flex flex-row justify-end">
                <button onClick={()=>{
                    handleChange({target: { name: 'slotToAssign', value: undefined }})
                }} className="underline text-xs">Reset Variable Selection</button>
            </div>

            <SentToUserSwitch formData={formData} setFormData={setFormData} skipNotify={formData.skipNotify}/>

        </div>
    )
}

export default AgentActionSettings
